import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { AppService } from '@app/app.service';
import { CustomMaterialModule } from '@app/core/material.module';
import { IPaletteRecord } from '@modules/palettes/interfaces/palettes.interface';

/**
 * Компонент легенды для палитры
 */
@Component({
    selector: 'app-palette-legend',
    templateUrl: './palette-legend.component.html',
    styleUrls: ['./palette-legend.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, CustomMaterialModule],
})
export class PaletteLegendComponent {
    readonly appService = inject(AppService);

    @Input() palette: IPaletteRecord | null = null;
}
